export default {"src":"/_next/static/media/lebanon.304dba41.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};